export const isWindowFullSized = () => {
  return (
    window.navigator.standalone ||
    (document.fullScreenElement && document.fullScreenElement !== null) ||
    document.mozFullScreen ||
    document.webkitIsFullScreen ||
    (!window.screenTop && !window.screenY)
  );
};
